import dayjs from '../../../utils/dayjs';
import { downloadGradebookExportV2 } from '../../../core/lms';
import { getUserTimezone } from '../../../utils/util';

export const exportGradebook = async ({
  exportOptions,
  course,
  studentIds,
}) => {
  const {
    id,
    data: { short_name: shortName },
  } = course;

  const userTimezone = getUserTimezone();
  const params = {
    includeTimeSpentData: exportOptions.INCLUDE_TIME_SPENT,
    includeAverageRowData: exportOptions.INCLUDE_COL_AVG,
    includeStudentIdType: exportOptions.INCLUDE_STUDENT_ID,
    includeForEachStudent: exportOptions.EACH_STUDENT,
    gradeFormat: exportOptions.GRADE_FORMAT,
    studentIds,
    userTimezone,
  };
  const blob = await downloadGradebookExportV2(id, params);

  // ensure course shortName only contains alphanumeric characters
  const sanitizedShortName = shortName.replace(/\W+/g, '');
  const filename = `Gradebook_${sanitizedShortName}_${dayjs().format(
    'MMDDYY',
  )}`;

  // For IE 10+
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, `${filename}.csv`);
  } else {
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `${filename}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
